/**
 * Partner architecture.
 * Internally prepared roles exist for future expansion.
 * Public website displays ONLY the strategic engineering partner: SAI Enterprises.
 */

export const PARTNER_ROLES = [
  "Partner",
  "Vendor",
  "Supplier",
  "Consultant",
  "OEM",
  "Contractor",
  "Distributor",
];

export const PARTNER_VISIBILITY = {
  PUBLIC: "public",
  INTERNAL: "internal",
};

/**
 * Public strategic engineering partner — the only partner shown on the website.
 * URL is never hardcoded; see config/env.js (REACT_APP_SAI_WEBSITE_URL / VITE_SAI_WEBSITE_URL).
 */
export const STRATEGIC_ENGINEERING_PARTNER = {
  id: "sai-enterprises",
  name: "SAI Enterprises",
  role: "Strategic Engineering Partner",
  visibility: PARTNER_VISIBILITY.PUBLIC,
  description:
    "Large-scale EPC and turnkey engineering projects are executed through our strategic engineering partner.",
  scope: [
    "Large Scale EPC Projects",
    "Turnkey Engineering Execution",
    "Multi-discipline Project Delivery",
  ],
  phone: "9510115313",
  email: "bhattdeb117@gmail.com",
};

/** Internal partner-role scaffolding — not rendered on the public website. */
export const INTERNAL_PARTNER_FRAMEWORK = PARTNER_ROLES.map((role) => ({
  role,
  visibility: PARTNER_VISIBILITY.INTERNAL,
  publicDisplay: false,
}));

export function getPublicPartners() {
  return [STRATEGIC_ENGINEERING_PARTNER];
}
